import { Menu } from "antd";

import {
  UserOutlined,
  HomeOutlined,
  SolutionOutlined,
  ShoppingCartOutlined,
  BulbOutlined,
  ShopOutlined,
  AccountBookOutlined,
  BarChartOutlined,
  CrownOutlined,
  BankOutlined
} from "@ant-design/icons";
import { connect } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { useLocation, Link } from "react-router-dom";

const findListCheck = (path, list = []) => {
  let selectedKeys = [];
  let openKeys = [];
  list.forEach((v) => {
    if (v.children && v.children.length > 0) {
      let childrenResult = findListCheck(path, v.children);
      selectedKeys = [...selectedKeys, ...childrenResult.selectedKeys];
      openKeys = [...openKeys, ...childrenResult.openKeys];
      if (
        childrenResult.openKeys &&
        childrenResult.openKeys.length > 0 &&
        v.parentId
      ) {
        openKeys.push(String(v.parentId));
      }
    } else {
      if (path === v.path) {
        selectedKeys.push(String(v.id));
        if (v.parentId) {
          openKeys.push(String(v.parentId));
        }
      }
    }
  });
  return {
    selectedKeys,
    openKeys,
  };
};
const getMenuItem = (item) => {
  if (item.children && item.children.length > 0) {
    return (
      <Menu.SubMenu icon={getMenuIcon(item)} title={item.name} key={item.id}>
        {item.children.map(getMenuItem)}
      </Menu.SubMenu>
    );
  } else {
    return (
      <Menu.Item key={String(item.id)} icon={getMenuIcon(item)}>
        <Link to={item.path}>{item.name}</Link>
      </Menu.Item>
    );
  }
};
const getMenuIcon = (item) => {
  return {
    home: <HomeOutlined />,
    purchase: <ShoppingCartOutlined />,
    supplier: <SolutionOutlined />,
    product: <BulbOutlined />,
    inventory: <ShopOutlined />,
    order: <AccountBookOutlined />,
    report: <BarChartOutlined />,
    activity: <CrownOutlined />,
    sys: <UserOutlined />,
    mallpage: <BankOutlined />,
  }[item.icon];
};
const MainMenu = ({ list }) => {
  const [$openKeys, set$openKeys] = useState([]);
  const [$selectedKeys, set$selectedKeys] = useState([]);
  const location = useLocation();
  const menuList = useMemo(() => {
    return [
      {
        id: Math.random(),
        path: "/",
        name: "首页",
        icon: "home",
      },
      ...(list || []),
    ];
  }, [list]);
  useEffect(() => {
    const { selectedKeys, openKeys } = findListCheck(
      location.pathname,
      menuList
    );
    set$openKeys(openKeys);
    set$selectedKeys(selectedKeys);
  }, [location.pathname, menuList]);
  return (
    <Menu
      mode="inline"
      selectedKeys={$selectedKeys}
      openKeys={$openKeys}
      onOpenChange={set$openKeys}
      theme="dark"
      className="no-scroller"
      style={{
        WebkitScrollbar: "display:none",
        top: 50,
        position: "absolute",
        bottom: 0,
        width: "100%",
        overflow: "auto",
        borderRight: 0,
        paddingBottom: 30,
      }}
    >
      {menuList.map((menuItem) => getMenuItem(menuItem))}
    </Menu>
  );
};
export default connect((state) => {
  return {
    list: state.auth.menuList,
  };
})(MainMenu);
